import React from 'react';
import { Store } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { TextField } from '@/components/text-field';
export function ShowroomConfigCard({ control, disabled, taglineField, currencyField, callField, whatsappField, telegramField, directionsField, }) {
    const { t } = useTranslation('campaign');
    return (<Card>
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <Store className="h-4 w-4"/>
                    {t('showroom_config.card_title')}
                </CardTitle>
                <CardDescription>{t('showroom_config.card_desc')}</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
                <TextField control={control} name={taglineField ?? 'showroomTagline'} label={t('showroom_config.tagline')} placeholder={t('showroom_config.tagline_placeholder')} description={t('showroom_config.tagline_desc')} disabled={disabled} autoComplete="off"/>

                <TextField control={control} name={currencyField ?? 'showroomCurrency'} label={t('showroom_config.currency')} placeholder="USD" description={t('showroom_config.currency_desc')} disabled={disabled} autoComplete="off"/>

                <div className="pt-4 border-t">
                    <p className="text-sm font-medium mb-1">{t('showroom_config.contacts_title')}</p>
                    <p className="text-xs text-muted-foreground mb-4">{t('showroom_config.contacts_desc')}</p>

                    <div className="grid gap-3 sm:grid-cols-2">
                        <TextField control={control} name={callField ?? 'showroomCallNumber'} label={t('showroom_config.call_number')} placeholder="+855 12 345 678" disabled={disabled} autoComplete="off"/>
                        <TextField control={control} name={whatsappField ?? 'showroomWhatsappNumber'} label={t('showroom_config.whatsapp_number')} placeholder="+855 12 345 678" disabled={disabled} autoComplete="off"/>
                        <TextField control={control} name={telegramField ?? 'showroomTelegramHandle'} label={t('showroom_config.telegram_handle')} placeholder="@yourhandle" disabled={disabled} autoComplete="off"/>
                        <TextField control={control} name={directionsField ?? 'showroomDirectionsUrl'} label={t('showroom_config.directions_url')} placeholder="https://maps.google.com/?q=..." disabled={disabled} autoComplete="off"/>
                    </div>
                </div>
            </CardContent>
        </Card>);
}
